import React, { useCallback } from 'react'
import s from './CritairChoice.less'
import T from '../i18n/T'
import classnames from 'classnames'

const CritairChoice = ({ critAirStickers, onSelect, value }) => {
  const onChooseForId = useCallback(
    id => evt => {
      evt.preventDefault()
      onSelect(id)
    },
    []
  )
  return (
    <div className={s.root}>
      <div className={s.title}>
        <T id={'itinerary.options.critair.label'} />
      </div>
      <ul>
        {critAirStickers.map(sticker => {
          const { icon, label, id, description } = sticker
          return (
            <li
              onClick={onChooseForId(id)}
              key={`sticker-${id}`}
              className={classnames(s.sticker, value === id && s.selected)}
            >
              <div className={s.iconWrapper}>
                <img src={icon} className={s.icon} />
              </div>

              <div className={s.content}>
                <div className={s.label}>{label}</div>
                <div>{description}</div>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default CritairChoice
